<template>
  <section>
    <div class="row bottom-margin">
              <div class="col-md-4">
                <div v-bind:class="getStyleClassForUserTypeRadioButton(userTypes.INVESTOR)">
                  <input type="radio" name="InvestorOption" id="InvestorOption" v-model="user.userType" value="INVESTOR"
                    v-bind:disabled="isFinanciaAdvisorOrAdmin()" />
                  <label for="InvestorOption">Investor</label>
                </div>
              </div>
              <div class="col-md-4">
                <div v-bind:class="getStyleClassForUserTypeRadioButton(userTypes.FINANCIAL_ADVISOR)">
                  <input type="radio" name="FinancialAdvisorOption" id="FinancialAdvisorOption" v-on:click="selectAdvisor()"
                    disabled v-model="user.userType" value="ADVISOR" />
                  <label for="FinancialAdvisorOption">Financial Advisor </label>
                </div>
              </div>
            </div>
            <div class="row bottom-margin">
              <div class="col-md-4">
                <div v-bind:class="getStyleClassForUserTypeRadioButton(userTypes.MINOR)">
                  <input type="radio" name="MinorOption" id="MinorOption" v-model="user.userType" value="MINOR"
                    v-bind:disabled="isFinanciaAdvisorOrAdmin()"/>
                  <label for="MinorOption">Minor</label>
                </div>
              </div>
              <div class="col-md-4">
                <div v-bind:class="getStyleClassForUserTypeRadioButton(userTypes.ADMIN)">
                  <input type="radio" name="AdminOption" id="AdminOption" disabled v-model="user.userType" value="ADMIN" />
                  <label for="AdminOption">Admin</label>
                </div>
              </div>
            </div>
            <div class="row bottom-margin">
              <div class="col-md-4">
                <div v-bind:class="getStyleClassForUserTypeRadioButton(userTypes.INSTITUTIONAL_REPRESENTATIVE)">
                  <input
                    type="radio"
                    name="InstitutionalRepresentativeOption"
                    id="InstitutionalRepresentativeOption"
                    disabled
                    v-model="user.userType"
                    value="INSTITUTIONAL_REPRESENTATIVE" />
                  <label for="InstitutionalRepresentativeOption">Institutional Representative</label>
                </div>
              </div>
            </div>
  </section>
</template>

<script>
  import {
    mapState,
  } from 'vuex';

  import { UserTypes } from '@/data/static/userTypes';

  export default {
    name: 'UserTypeSelection',
    props: ['user',
    ],
    data() {
      return {
        userTypes: UserTypes,
      };
    },
    computed: {
      ...mapState('authentication', [
        'states',
      ]),
    },
    methods: {
      getStyleClassForUserTypeRadioButton(type) {
        return this.user.userType === type.name
          ? 'radio-item' : 'radio-item radio-item-unselected';
      },
      isFinanciaAdvisorOrAdmin() {
        return this.user.userType === UserTypes.FINANCIAL_ADVISOR.name
          || this.user.userType === UserTypes.ADMIN.name;
      },
    },
  };
</script>

<style scoped>
  .radio-item label {
    color: #666;
    font-weight: normal;
  }

  .radio-item label:before {
    content: " ";
    display: inline-block;
    position: relative;
    top: 5px;
    left: 0px;
    margin: 0 5px 0 0;
    width: 20px;
    height: 20px;
    border-radius: 11px;
    background-color: transparent;
  }

  .radio-item-unselected label:before {
    border: 2px solid #d3d3d3;
  }

  .radio-item input[type=radio]:checked+label:after {
    border-radius: 11px;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 10px;
    left: 11px;
    content: " ";
    display: block;
  }
</style>



// WEBPACK FOOTER //
// UserTypeSelection.vue?05030172